import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PamlabApiServiceService } from '@/shared/services';
import { DataService } from '@/shared/services';
import { HttpErrorResponse } from '@angular/common/http';

interface DataProps {
  form_title: 'Add At-Risk Comment' | 'Mark Student At-Risk';
  selected_demo_time_frame: number;
  at_risk_student_id: number;
  uwf_id: number;
  cohort: number;
}

@Component({
  selector: 'app-at-risk-student-popup-form',
  templateUrl: './at-risk-student-popup-form.component.html',
  styleUrls: ['./at-risk-student-popup-form.component.css'],
  standalone: false,
})
export class AtRiskStudentPopupFormComponent implements OnInit {
  // variables to generate list of values for dropdown
  reasonList: string[] = [
    'Academic',
    'Health',
    'Financial',
    'Transfer Out',
    'Other',
  ];
  // variables to keep track of chosen values by user to get data
  chosenReasons: string[] = [];
  // boolean variables for event variable in function
  isReasonClose!: boolean;
  // to save form values for values selected
  reasonChosen = new FormControl();

  // prerequisites form group
  public atRiskStudentForm = new FormGroup({
    at_risk_reasons: new FormControl([], [Validators.required]),
    comment: new FormControl('', [Validators.required]),
    demo_time_frame: new FormControl(0, [
      Validators.required,
      Validators.min(1),
    ]),
  });

  constructor(
    public dialog: MatDialog,
    public apiService: PamlabApiServiceService,
    private dataService: DataService,
    @Inject(MAT_DIALOG_DATA)
    public data: Partial<DataProps>,
  ) {}

  ngOnInit(): void {
    this.atRiskStudentForm.patchValue({
      demo_time_frame: this.data.selected_demo_time_frame!,
    });
    this.atRiskStudentForm.get('demo_time_frame')?.disable();
  }

  // submit at-risk student form and call endpoint to patch values
  atRiskStudentFormSubmit() {
    // if student has already been marked at-risk
    // user can add extra comments to student that has been marked
    if (this.data.form_title === 'Add At-Risk Comment') {
      this.apiService
        .addAtRiskCommentsToStudent({
          at_risk_student_id: this.data.at_risk_student_id!,
          comment: this.atRiskStudentForm.value.comment!,
          categories: this.atRiskStudentForm.value.at_risk_reasons!.join(', '),
        })
        .subscribe({
          next: (data) => {
            this.dataService.setAtRiskCommentData({ data });
          },
          error: (errorRes: HttpErrorResponse) => {
            this.dataService.setAtRiskCommentData({ error: errorRes.error });
          },
        });
    }

    if (this.data.form_title === 'Mark Student At-Risk') {
      this.apiService
        .markAtRiskStudent({
          uwf_id: this.data.uwf_id!,
          cohort: this.data.cohort!,
          demo_time_frame: this.data.selected_demo_time_frame!,
          comment: this.atRiskStudentForm.value.comment!,
          categories: this.atRiskStudentForm.value.at_risk_reasons!.join(', '),
        })
        .subscribe({
          next: (data) => {
            this.dataService.setAtRiskStudentData({ data });
          },
          error: (errorRes: HttpErrorResponse) => {
            this.dataService.setAtRiskStudentData({ error: errorRes.error });
          },
        });
    }
  }

  // close popup dialog after form is submitted
  closeDialog() {
    this.dialog.closeAll();
  }
}
